// extracted by mini-css-extract-plugin
export var root = "SwatchList-module--root--jRLo2";
export var label = "SwatchList-module--label--sSvhu";
export var swatchSelection = "SwatchList-module--swatchSelection--qVsfH";